// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  color: #253750;
  font-size: 12px;
  --mat-form-field-container-text-size: 12px;
  --mat-select-trigger-text-size: 12px;
}

.form-container {
  padding: 24px;
  border: 1px solid #e2e9f2;
  border-radius: 12px;
  background: white;
}

.product-input-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
  margin-bottom: 18px;
}

.form-inputs {
  flex: 1 1 calc(50% - 18px);
  min-width: 0;
}

.width-100,
.w-100 {
  flex-basis: 100%;
}

mat-form-field {
  display: block;
  width: 100%;
}

.field-display {
  border: 1px solid #e2e9f2;
  border-radius: 8px;
  padding: 12px;
}

.field-display > span:first-child {
  display: block;
  color: #7d8a9d;
  margin-bottom: 8px;
}

.error-msg {
  display: block;
  color: #d92d20;
  font-size: 11px;
  margin-top: 6px;
}

.select-label-text {
  display: block;
  font-size: 11px;
  color: #53647a;
  margin-bottom: 6px;
}

.title3,
.title {
  font-size: 14px;
  font-weight: 600;
  color: #172b46;
}

.note-container {
  padding: 12px 16px;
  background: #fff8e6;
  border-radius: 8px;
  margin-bottom: 16px;
}

mat-accordion {
  display: block;
  margin: 20px 0;
}

mat-expansion-panel {
  box-shadow: none !important;
  border: 1px solid #e2e9f2;
  border-radius: 8px !important;
  margin-bottom: 12px;
}

.product-bottom-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding-top: 20px;
  margin-top: 24px;
  border-top: 1px solid #edf1f6;
}

.product-bottom-container mat-spinner {
  display: inline-block;
  margin-inline-end: 8px;
}

.prev {
  cursor: pointer;
  color: var(--primary-color);
}

.listing-table,
.table-scroll {
  overflow: auto;
}

table {
  border-collapse: collapse;
  width: 100%;
  font-size: 12px;
}

th,
td {
  padding: 12px;
  text-align: start;
  border-bottom: 1px solid #edf1f6;
}

th {
  background: #f8fafd;
  color: #7d8a9d;
  font-weight: 500;
}

.preview-image,
.related-preview-img {
  width: 48px;
  height: 48px;
  object-fit: contain;
  border-radius: 8px;
}

.image-container,
.variation-image {
  display: inline-flex;
  max-width: 160px;
  padding: 8px;
  border: 1px solid #e2e9f2;
  border-radius: 8px;
  margin: 4px;
}

.image-container img,
.variation-image img {
  max-width: 100%;
  max-height: 140px;
  object-fit: contain;
}

.image-section {
  padding: 16px;
  background: #f8fafd;
  border-radius: 8px;
}

.checkbox-wrap,
.sku-check {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}

.checkbox-content {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.product-button {
  display: flex;
  justify-content: flex-end;
}

.image-upload-container,
.file-upload-container {
  border: 1px dashed #dce5ef;
  border-radius: 8px;
  padding: 20px;
}

.tag-cover-box {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.grey-box {
  padding: 6px 10px;
  background: #f1f6fd;
  border-radius: 6px;
}

.price-group-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 16px 0;
}

dt {
  color: #7d8a9d;
  font-size: 11px;
}

dd {
  margin: 6px 0;
}

@media (max-width: 650px) {
  .form-container {
    padding: 16px;
  }
  .form-inputs {
    flex-basis: 100%;
  }
  .product-input-wrap {
    gap: 14px;
  }
}
:host {
  display: block;
  container-type: inline-size;
  font-size: 12px;
  --cf-ink: var(--primary-font-color, #172b46);
  --cf-text: var(--primary-font-color, #35445b);
  --cf-muted: var(--secondary-grey-color, #7d8a9d);
  --cf-border: color-mix(in srgb, var(--grey-border, #D5D7DA) 70%, white);
  --cf-divider: color-mix(in srgb, var(--grey-border, #D5D7DA) 45%, white);
  --cf-soft: color-mix(in srgb, var(--primary-color) 3%, white);
  --cf-tint: color-mix(in srgb, var(--primary-color) 8%, white);
  --cf-tint-text: color-mix(in srgb, var(--primary-color) 75%, black);
  color: var(--cf-text);
}

.config-step {
  display: grid;
  gap: 16px;
  margin-top: 20px;
}

.step-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.step-head h2 {
  margin: 0;
  color: var(--cf-ink);
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
}
.step-head p {
  margin: 2px 0 0;
  color: var(--cf-muted);
  font-size: 12px;
}

.count,
.code {
  border-radius: 5px;
  padding: 2px 8px;
  background: var(--cf-tint);
  color: var(--cf-tint-text);
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

.state-card {
  display: grid;
  justify-items: center;
  gap: 8px;
  padding: 40px 20px;
  border: 1px solid var(--cf-border);
  border-radius: 12px;
  background: #fff;
  text-align: center;
}
.state-card p {
  margin: 0;
  max-width: 420px;
  color: var(--cf-muted);
  font-size: 12px;
  line-height: 1.5;
}
.state-card h3 {
  margin: 0;
  color: var(--cf-ink);
  font-size: 14px;
  font-weight: 600;
}
.state-card.empty {
  border-style: dashed;
}
.state-card.empty > .material-symbols-outlined {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: var(--cf-tint);
  color: var(--primary-color);
  font-size: 22px;
}

.price-groups {
  display: grid;
  gap: 10px;
}
.price-groups .mat-expansion-panel {
  border: 1px solid var(--cf-border);
  border-radius: 12px !important;
  box-shadow: none !important;
  overflow: hidden;
}
.price-groups .mat-expansion-panel ::ng-deep .mat-expansion-panel-header {
  height: 52px !important;
  padding: 0 18px !important;
}
.price-groups .mat-expansion-panel ::ng-deep .mat-expansion-panel-header.mat-expanded {
  background: var(--cf-soft);
  border-bottom: 1px solid var(--cf-divider);
}
.price-groups .mat-expansion-panel ::ng-deep .mat-expansion-panel-body {
  padding: 14px 18px 18px !important;
}
.price-groups mat-panel-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.price-groups .group-name {
  color: var(--cf-ink);
  font-size: 13px;
  font-weight: 600;
}

.detail-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0 20px;
  margin-bottom: 14px;
}

.detail-item {
  display: grid;
  gap: 4px;
  padding: 10px 0;
  border-bottom: 1px solid var(--cf-divider);
}
.detail-item span {
  color: var(--cf-muted);
  font-size: 10px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
}
.detail-item strong {
  color: var(--cf-ink);
  font-size: 13px;
  font-weight: 500;
}

.table-scroll {
  overflow-x: auto;
  border: 1px solid var(--cf-border);
  border-radius: 10px;
  scrollbar-width: thin;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.data-table th {
  background: var(--cf-soft);
  color: var(--cf-muted);
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  white-space: nowrap;
}
.data-table th,
.data-table td {
  padding: 11px 14px;
  text-align: start;
  border-bottom: 1px solid var(--cf-divider);
}
.data-table tbody tr:last-child td {
  border-bottom: 0;
}
.data-table .num {
  text-align: end;
}
.data-table .price {
  color: var(--cf-ink);
  font-weight: 600;
}
.data-table .code-cell {
  color: var(--primary-color);
  font-weight: 500;
}
.data-table .muted {
  color: var(--cf-muted);
  white-space: nowrap;
}
.data-table .center {
  text-align: center;
}

.status {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 20px;
  padding: 3px 8px;
  background: #f1f3f7;
  color: var(--cf-muted);
  font-size: 10px;
  white-space: nowrap;
}
.status > span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: currentColor;
}
.status.enabled {
  background: #eef7f2;
  color: #36866a;
}

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  min-height: 36px;
  padding: 7px 14px;
  border: 1px solid var(--cf-border);
  border-radius: 8px;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}
.button .material-symbols-outlined {
  font-size: 18px;
  line-height: 1;
}
.button.primary {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: #fff;
}
.button.primary:hover:not(:disabled) {
  background: var(--primary-color-hover, var(--primary-color));
}
.button.primary ::ng-deep .mat-mdc-progress-spinner circle {
  stroke: #fff !important;
}
.button.secondary {
  background: #fff;
  color: var(--cf-text);
}
.button.secondary:hover {
  color: var(--primary-color);
  border-color: color-mix(in srgb, var(--primary-color) 30%, white);
  background: var(--cf-soft);
}
.button:disabled {
  opacity: 0.55;
  cursor: default;
}

.step-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid var(--cf-divider);
}

@container (max-width: 640px) {
  .detail-grid {
    grid-template-columns: 1fr;
  }
  .step-head {
    align-items: flex-start;
  }
  .step-footer .button {
    flex: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/product-editor.scss","webpack://./src/app/components/product-configuration/product-configuration.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,0CAAA;EACA,oCAAA;ACCJ;;ADEA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,0BAAA;EACA,YAAA;ACCJ;;ADEA;;EAEI,gBAAA;ACCJ;;ADEA;EACI,cAAA;EACA,WAAA;ACCJ;;ADEA;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;ACCJ;;ADEA;EACI,cAAA;EACA,cAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,cAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;ACCJ;;ADEA;EACI,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;ACCJ;;ADEA;;EAEI,eAAA;EACA,gBAAA;EACA,cAAA;ACCJ;;ADEA;EACI,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,cAAA;EACA,cAAA;ACCJ;;ADEA;EACI,2BAAA;EACA,yBAAA;EACA,6BAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,6BAAA;ACCJ;;ADEA;EACI,qBAAA;EACA,sBAAA;ACCJ;;ADEA;EACI,eAAA;EACA,2BAAA;ACCJ;;ADEA;;EAEI,cAAA;ACCJ;;ADEA;EACI,yBAAA;EACA,WAAA;EACA,eAAA;ACCJ;;ADEA;;EAEI,aAAA;EACA,iBAAA;EACA,gCAAA;ACCJ;;ADEA;EACI,mBAAA;EACA,cAAA;EACA,gBAAA;ACCJ;;ADEA;;EAEI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;ACCJ;;ADEA;;EAEI,oBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;ACCJ;;ADEA;;EAEI,eAAA;EACA,iBAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;ACCJ;;ADEA;;EAEI,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;ACCJ;;ADEA;EACI,aAAA;EACA,yBAAA;ACCJ;;ADEA;;EAEI,0BAAA;EACA,kBAAA;EACA,aAAA;ACCJ;;ADEA;EACI,aAAA;EACA,QAAA;EACA,eAAA;ACCJ;;ADEA;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;ACCJ;;ADEA;EACI,aAAA;EACA,eAAA;EACA,SAAA;EACA,eAAA;ACCJ;;ADEA;EACI,cAAA;EACA,eAAA;ACCJ;;ADEA;EACI,aAAA;ACCJ;;ADEA;EACI;IACI,aAAA;ECCN;EDEE;IACI,gBAAA;ECAN;EDGE;IACI,SAAA;ECDN;AACF;AAlOA;EACC,cAAA;EACA,2BAAA;EACA,eAAA;EAEA,4CAAA;EACA,6CAAA;EACA,gDAAA;EACA,uEAAA;EACA,wEAAA;EACA,6DAAA;EACA,6DAAA;EACA,mEAAA;EACA,qBAAA;AAmOD;;AAhOA;EACC,aAAA;EACA,SAAA;EACA,gBAAA;AAmOD;;AAhOA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAmOD;AAjOC;EACC,SAAA;EACA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAmOF;AAhOC;EACC,eAAA;EACA,sBAAA;EACA,eAAA;AAkOF;;AA9NA;;EAEC,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,0BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAiOD;;AA9NA;EACC,aAAA;EACA,qBAAA;EACA,QAAA;EACA,kBAAA;EACA,kCAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAiOD;AA/NC;EACC,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AAiOF;AA9NC;EACC,SAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;AAgOF;AA7NC;EACC,oBAAA;AA+NF;AA7NE;EACC,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EACA,2BAAA;EACA,eAAA;AA+NH;;AA1NA;EACC,aAAA;EACA,SAAA;AA6ND;AA3NC;EACC,kCAAA;EACA,8BAAA;EACA,2BAAA;EACA,gBAAA;AA6NF;AA3NE;EACC,uBAAA;EACA,0BAAA;AA6NH;AA1NE;EACC,0BAAA;EACA,0CAAA;AA4NH;AAzNE;EACC,kCAAA;AA2NH;AAvNC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAyNF;AAtNC;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;AAwNF;;AApNA;EACC,aAAA;EACA,gDAAA;EACA,WAAA;EACA,mBAAA;AAuND;;AApNA;EACC,aAAA;EACA,QAAA;EACA,eAAA;EACA,0CAAA;AAuND;AArNC;EACC,sBAAA;EACA,eAAA;EACA,qBAAA;EACA,yBAAA;AAuNF;AApNC;EACC,oBAAA;EACA,eAAA;EACA,gBAAA;AAsNF;;AAlNA;EACC,gBAAA;EACA,kCAAA;EACA,mBAAA;EACA,qBAAA;AAqND;;AAlNA;EACC,WAAA;EACA,yBAAA;EACA,eAAA;AAqND;AAnNC;EACC,0BAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,yBAAA;EACA,mBAAA;AAqNF;AAlNC;;EAEC,kBAAA;EACA,iBAAA;EACA,0CAAA;AAoNF;AAjNC;EACC,gBAAA;AAmNF;AAhNC;EACC,eAAA;AAkNF;AA/MC;EACC,oBAAA;EACA,gBAAA;AAiNF;AA9MC;EACC,2BAAA;EACA,gBAAA;AAgNF;AA7MC;EACC,sBAAA;EACA,mBAAA;AA+MF;AA5MC;EACC,kBAAA;AA8MF;;AA1MA;EACC,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,mBAAA;AA6MD;AA3MC;EACC,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wBAAA;AA6MF;AA1MC;EACC,mBAAA;EACA,cAAA;AA4MF;;AAxMA;EACC,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;AA2MD;AAzMC;EACC,eAAA;EACA,cAAA;AA2MF;AAxMC;EACC,gCAAA;EACA,kCAAA;EACA,WAAA;AA0MF;AAxME;EACC,4DAAA;AA0MH;AAvME;EACC,uBAAA;AAyMH;AArMC;EACC,gBAAA;EACA,qBAAA;AAuMF;AArME;EACC,2BAAA;EACA,iEAAA;EACA,0BAAA;AAuMH;AAnMC;EACC,aAAA;EACA,eAAA;AAqMF;;AAjMA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,uCAAA;AAoMD;;AAjMA;EACC;IACC,0BAAA;EAoMA;EAjMD;IACC,uBAAA;EAmMA;EAhMD;IACC,OAAA;EAkMA;AACF","sourcesContent":[":host {\n    display: block;\n    color: #253750;\n    font-size: 12px;\n    --mat-form-field-container-text-size: 12px;\n    --mat-select-trigger-text-size: 12px;\n}\n\n.form-container {\n    padding: 24px;\n    border: 1px solid #e2e9f2;\n    border-radius: 12px;\n    background: white;\n}\n\n.product-input-wrap {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 18px;\n    margin-bottom: 18px;\n}\n\n.form-inputs {\n    flex: 1 1 calc(50% - 18px);\n    min-width: 0;\n}\n\n.width-100,\n.w-100 {\n    flex-basis: 100%;\n}\n\nmat-form-field {\n    display: block;\n    width: 100%;\n}\n\n.field-display {\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    padding: 12px;\n}\n\n.field-display>span:first-child {\n    display: block;\n    color: #7d8a9d;\n    margin-bottom: 8px;\n}\n\n.error-msg {\n    display: block;\n    color: #d92d20;\n    font-size: 11px;\n    margin-top: 6px;\n}\n\n.select-label-text {\n    display: block;\n    font-size: 11px;\n    color: #53647a;\n    margin-bottom: 6px;\n}\n\n.title3,\n.title {\n    font-size: 14px;\n    font-weight: 600;\n    color: #172b46;\n}\n\n.note-container {\n    padding: 12px 16px;\n    background: #fff8e6;\n    border-radius: 8px;\n    margin-bottom: 16px;\n}\n\nmat-accordion {\n    display: block;\n    margin: 20px 0;\n}\n\nmat-expansion-panel {\n    box-shadow: none !important;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px !important;\n    margin-bottom: 12px;\n}\n\n.product-bottom-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding-top: 20px;\n    margin-top: 24px;\n    border-top: 1px solid #edf1f6;\n}\n\n.product-bottom-container mat-spinner {\n    display: inline-block;\n    margin-inline-end: 8px;\n}\n\n.prev {\n    cursor: pointer;\n    color: var(--primary-color);\n}\n\n.listing-table,\n.table-scroll {\n    overflow: auto;\n}\n\ntable {\n    border-collapse: collapse;\n    width: 100%;\n    font-size: 12px;\n}\n\nth,\ntd {\n    padding: 12px;\n    text-align: start;\n    border-bottom: 1px solid #edf1f6;\n}\n\nth {\n    background: #f8fafd;\n    color: #7d8a9d;\n    font-weight: 500;\n}\n\n.preview-image,\n.related-preview-img {\n    width: 48px;\n    height: 48px;\n    object-fit: contain;\n    border-radius: 8px;\n}\n\n.image-container,\n.variation-image {\n    display: inline-flex;\n    max-width: 160px;\n    padding: 8px;\n    border: 1px solid #e2e9f2;\n    border-radius: 8px;\n    margin: 4px;\n}\n\n.image-container img,\n.variation-image img {\n    max-width: 100%;\n    max-height: 140px;\n    object-fit: contain;\n}\n\n.image-section {\n    padding: 16px;\n    background: #f8fafd;\n    border-radius: 8px;\n}\n\n.checkbox-wrap,\n.sku-check {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    align-items: center;\n}\n\n.checkbox-content {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n}\n\n.product-button {\n    display: flex;\n    justify-content: flex-end;\n}\n\n.image-upload-container,\n.file-upload-container {\n    border: 1px dashed #dce5ef;\n    border-radius: 8px;\n    padding: 20px;\n}\n\n.tag-cover-box {\n    display: flex;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.grey-box {\n    padding: 6px 10px;\n    background: #f1f6fd;\n    border-radius: 6px;\n}\n\n.price-group-summary {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 24px;\n    padding: 16px 0;\n}\n\ndt {\n    color: #7d8a9d;\n    font-size: 11px;\n}\n\ndd {\n    margin: 6px 0;\n}\n\n@media(max-width:650px) {\n    .form-container {\n        padding: 16px;\n    }\n\n    .form-inputs {\n        flex-basis: 100%;\n    }\n\n    .product-input-wrap {\n        gap: 14px;\n    }\n}","@import '../../../theme/product-editor';\n\n// Step 2 - Price groups. Same design + theme tokens as Product details / Preview.\n:host {\n\tdisplay: block;\n\tcontainer-type: inline-size;\n\tfont-size: 12px;\n\n\t--cf-ink: var(--primary-font-color, #172b46);\n\t--cf-text: var(--primary-font-color, #35445b);\n\t--cf-muted: var(--secondary-grey-color, #7d8a9d);\n\t--cf-border: color-mix(in srgb, var(--grey-border, #D5D7DA) 70%, white);\n\t--cf-divider: color-mix(in srgb, var(--grey-border, #D5D7DA) 45%, white);\n\t--cf-soft: color-mix(in srgb, var(--primary-color) 3%, white);\n\t--cf-tint: color-mix(in srgb, var(--primary-color) 8%, white);\n\t--cf-tint-text: color-mix(in srgb, var(--primary-color) 75%, black);\n\tcolor: var(--cf-text);\n}\n\n.config-step {\n\tdisplay: grid;\n\tgap: 16px;\n\tmargin-top: 20px;\n}\n\n.step-head {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 12px;\n\n\th2 {\n\t\tmargin: 0;\n\t\tcolor: var(--cf-ink);\n\t\tfont-size: 16px;\n\t\tline-height: 24px;\n\t\tfont-weight: 600;\n\t}\n\n\tp {\n\t\tmargin: 2px 0 0;\n\t\tcolor: var(--cf-muted);\n\t\tfont-size: 12px;\n\t}\n}\n\n.count,\n.code {\n\tborder-radius: 5px;\n\tpadding: 2px 8px;\n\tbackground: var(--cf-tint);\n\tcolor: var(--cf-tint-text);\n\tfont-size: 11px;\n\tfont-weight: 500;\n\twhite-space: nowrap;\n}\n\n.state-card {\n\tdisplay: grid;\n\tjustify-items: center;\n\tgap: 8px;\n\tpadding: 40px 20px;\n\tborder: 1px solid var(--cf-border);\n\tborder-radius: 12px;\n\tbackground: #fff;\n\ttext-align: center;\n\n\tp {\n\t\tmargin: 0;\n\t\tmax-width: 420px;\n\t\tcolor: var(--cf-muted);\n\t\tfont-size: 12px;\n\t\tline-height: 1.5;\n\t}\n\n\th3 {\n\t\tmargin: 0;\n\t\tcolor: var(--cf-ink);\n\t\tfont-size: 14px;\n\t\tfont-weight: 600;\n\t}\n\n\t&.empty {\n\t\tborder-style: dashed;\n\n\t\t>.material-symbols-outlined {\n\t\t\tdisplay: grid;\n\t\t\tplace-items: center;\n\t\t\twidth: 44px;\n\t\t\theight: 44px;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground: var(--cf-tint);\n\t\t\tcolor: var(--primary-color);\n\t\t\tfont-size: 22px;\n\t\t}\n\t}\n}\n\n.price-groups {\n\tdisplay: grid;\n\tgap: 10px;\n\n\t.mat-expansion-panel {\n\t\tborder: 1px solid var(--cf-border);\n\t\tborder-radius: 12px !important;\n\t\tbox-shadow: none !important;\n\t\toverflow: hidden;\n\n\t\t::ng-deep .mat-expansion-panel-header {\n\t\t\theight: 52px !important;\n\t\t\tpadding: 0 18px !important;\n\t\t}\n\n\t\t::ng-deep .mat-expansion-panel-header.mat-expanded {\n\t\t\tbackground: var(--cf-soft);\n\t\t\tborder-bottom: 1px solid var(--cf-divider);\n\t\t}\n\n\t\t::ng-deep .mat-expansion-panel-body {\n\t\t\tpadding: 14px 18px 18px !important;\n\t\t}\n\t}\n\n\tmat-panel-title {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tgap: 10px;\n\t}\n\n\t.group-name {\n\t\tcolor: var(--cf-ink);\n\t\tfont-size: 13px;\n\t\tfont-weight: 600;\n\t}\n}\n\n.detail-grid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, minmax(0, 1fr));\n\tgap: 0 20px;\n\tmargin-bottom: 14px;\n}\n\n.detail-item {\n\tdisplay: grid;\n\tgap: 4px;\n\tpadding: 10px 0;\n\tborder-bottom: 1px solid var(--cf-divider);\n\n\tspan {\n\t\tcolor: var(--cf-muted);\n\t\tfont-size: 10px;\n\t\tletter-spacing: .3px;\n\t\ttext-transform: uppercase;\n\t}\n\n\tstrong {\n\t\tcolor: var(--cf-ink);\n\t\tfont-size: 13px;\n\t\tfont-weight: 500;\n\t}\n}\n\n.table-scroll {\n\toverflow-x: auto;\n\tborder: 1px solid var(--cf-border);\n\tborder-radius: 10px;\n\tscrollbar-width: thin;\n}\n\n.data-table {\n\twidth: 100%;\n\tborder-collapse: collapse;\n\tfont-size: 12px;\n\n\tth {\n\t\tbackground: var(--cf-soft);\n\t\tcolor: var(--cf-muted);\n\t\tfont-size: 10px;\n\t\tfont-weight: 500;\n\t\tletter-spacing: .3px;\n\t\ttext-transform: uppercase;\n\t\twhite-space: nowrap;\n\t}\n\n\tth,\n\ttd {\n\t\tpadding: 11px 14px;\n\t\ttext-align: start;\n\t\tborder-bottom: 1px solid var(--cf-divider);\n\t}\n\n\ttbody tr:last-child td {\n\t\tborder-bottom: 0;\n\t}\n\n\t.num {\n\t\ttext-align: end;\n\t}\n\n\t.price {\n\t\tcolor: var(--cf-ink);\n\t\tfont-weight: 600;\n\t}\n\n\t.code-cell {\n\t\tcolor: var(--primary-color);\n\t\tfont-weight: 500;\n\t}\n\n\t.muted {\n\t\tcolor: var(--cf-muted);\n\t\twhite-space: nowrap;\n\t}\n\n\t.center {\n\t\ttext-align: center;\n\t}\n}\n\n.status {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tgap: 5px;\n\tborder-radius: 20px;\n\tpadding: 3px 8px;\n\tbackground: #f1f3f7;\n\tcolor: var(--cf-muted);\n\tfont-size: 10px;\n\twhite-space: nowrap;\n\n\t>span {\n\t\twidth: 4px;\n\t\theight: 4px;\n\t\tborder-radius: 50%;\n\t\tbackground: currentColor;\n\t}\n\n\t&.enabled {\n\t\tbackground: #eef7f2;\n\t\tcolor: #36866a;\n\t}\n}\n\n.button {\n\tdisplay: inline-flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 7px;\n\tmin-height: 36px;\n\tpadding: 7px 14px;\n\tborder: 1px solid var(--cf-border);\n\tborder-radius: 8px;\n\tfont: inherit;\n\tfont-size: 12px;\n\tfont-weight: 500;\n\tcursor: pointer;\n\twhite-space: nowrap;\n\n\t.material-symbols-outlined {\n\t\tfont-size: 18px;\n\t\tline-height: 1;\n\t}\n\n\t&.primary {\n\t\tbackground: var(--primary-color);\n\t\tborder-color: var(--primary-color);\n\t\tcolor: #fff;\n\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground: var(--primary-color-hover, var(--primary-color));\n\t\t}\n\n\t\t::ng-deep .mat-mdc-progress-spinner circle {\n\t\t\tstroke: #fff !important;\n\t\t}\n\t}\n\n\t&.secondary {\n\t\tbackground: #fff;\n\t\tcolor: var(--cf-text);\n\n\t\t&:hover {\n\t\t\tcolor: var(--primary-color);\n\t\t\tborder-color: color-mix(in srgb, var(--primary-color) 30%, white);\n\t\t\tbackground: var(--cf-soft);\n\t\t}\n\t}\n\n\t&:disabled {\n\t\topacity: .55;\n\t\tcursor: default;\n\t}\n}\n\n.step-footer {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 12px;\n\tpadding-top: 16px;\n\tborder-top: 1px solid var(--cf-divider);\n}\n\n@container (max-width: 640px) {\n\t.detail-grid {\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t.step-head {\n\t\talign-items: flex-start;\n\t}\n\n\t.step-footer .button {\n\t\tflex: 1;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
